import { useEffect, useState } from "react";
import "./Sidebar.scss";
import {
  Menu,
  MenuItem,
  Sidebar,
  SubMenu,
  useProSidebar,
} from "react-pro-sidebar";
import { useTranslation } from "react-i18next";
import {
  I18_TRANSLATION_COMMON,
  LANGUAGES,
  SIDEBAR,
  STORAGE_KEYS,
} from "../../Utilities/Constants/Constants";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import img from "../../../Assets/sidebar/phygital_Logo.svg";
import mobile_logo from "../../../Assets/sidebar/main_logo_mobile.svg";
import menu from "../../../Assets/sidebar/menu.svg";
import menu_mobile from "../../../Assets/sidebar/menu_mobile.svg";
import { GetSessionStorageData } from "../../Services/Helpers/Helper";

const SideBar = () => {
  const { collapseSidebar, collapsed } = useProSidebar();
  const [isMobile, setMobileScreen] = useState(false);
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    window.screen.width <= 960 ? collapseSidebar(true) : collapseSidebar(false);
  }, [collapseSidebar]);

  const detectWindowSize = () => {
    if (window.innerWidth <= 960) {
      collapseSidebar(true);
      setMobileScreen(true);
    } else {
      collapseSidebar(false);
      setMobileScreen(false);
    }
    if (window.innerWidth <= 576) {
      setMobileScreen(true);
    } else {
      setMobileScreen(false);
    }
  };

  window.onresize = detectWindowSize;
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  const location = useLocation();

  const isPathActive = (path: string) => {
    return location.pathname.startsWith(path);
  };

  const handleSidebarCollapse = ()=>{
    if(isMobile)
      collapseSidebar(true);
  }

  return (
    <>
      <Sidebar
        className="sidbar-wrap"
        width={isMobile ? "100%" : "250px"}
        collapsedWidth={isMobile ? "0px" : "80px"}
        transitionDuration={500}
        rtl={language === LANGUAGES.ENGLISH ? false : true}
      >
        {/* <div
          className={
            collapsed
              ? "main_logo_menu_wrapper_mobile"
              : "main_logo_menu_wrapper"
          }
        >
          {collapsed ? (
            <img
              className=""
              src={mobile_logo}
              alt="Learn and Play"
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          ) : (
            <img
              className="sidebar_logo_icon"
              src={img}
              alt="Learn and Play"
              onClick={() => {
                navigate("/dashboard");
              }}
            />
          )}
          {collapsed ? (
            <img
              src={menu_mobile}
              className={
                language === "English" ? "menu_toggle_ltr" : "menu_toggle_rtl"
              }
              onClick={() => collapseSidebar()}
              alt="Learn and Play"
            />
          ) : (
            <img
              src={menu}
              className={
                language === "English" ? "menu_toggle_ltr" : "menu_toggle_rtl"
              }
              onClick={() => collapseSidebar()}
              alt="Learn and Play"
            />
          )}
        </div> */}
        <Menu closeOnClick={isMobile ? true : false}>
          {SIDEBAR.map((sidebarElements: any, index: any) => {
            if(sidebarElements.ROLE.includes(GetSessionStorageData(STORAGE_KEYS.ROLE))){
              return (
                <>
                  {sidebarElements.SUB_MENU.length === 0 ? (
                    
                    <MenuItem
                      key={index}
                      className={
                        isPathActive(sidebarElements.PATH)
                          ? "menu-item menu_active"
                          : "menu-item menu_inactive"
                      }
                      active={isPathActive(sidebarElements.PATH)}
                      onClick={() => {
                        handleSidebarCollapse();
                        navigate(sidebarElements.PATH);
                      }}
                      icon={
                        <img
                          src={
                            isPathActive(sidebarElements.PATH)
                              ? sidebarElements.ACTIVE_ICON
                              : sidebarElements.ICON
                          }
                          alt={sidebarElements.NAME}
                        />
                      }
                    >
                      {t(`${sidebarElements.NAME}`)}{" "}
                    </MenuItem>
                  ) : (
                    <SubMenu
                      // className={
                      //   isPathActive(sidebarElements.PATH)
                      //     ? "menu-item menu_active"
                      //     : "menu-item menu_inactive"
                      // }
                      key={index}
                      className="sub_menu_wrapper"
                      label={t(`${sidebarElements.NAME}`)}
                      icon={
                        <img
                          src={sidebarElements.ICON}
                          alt={sidebarElements.NAME}
                        />
                      }
                      defaultOpen={
                        sidebarElements.SUB_MENU.filter((subMenu: any) => {
                          return isPathActive(subMenu.PATH);
                        }).length != 0
                      }
                    >
                      {sidebarElements.SUB_MENU.map(
                        (subMenuElements: any, index: any) => {
                          return (
                            <>
                              <MenuItem
                                key={index}
                                className={
                                  isPathActive(subMenuElements.PATH)
                                    ? "menu-item menu_active"
                                    : "menu-item menu_inactive"
                                }
                                active={isPathActive(subMenuElements.PATH)}
                                onClick={() => {
                                  navigate(subMenuElements.PATH);
                                }}
                              >
                                {t(`${subMenuElements.NAME}`)}{" "}
                              </MenuItem>
                            </>
                          );
                        }
                      )}
                    </SubMenu>
                  )}
                </>
              );
            }
            
          })}
        </Menu>
      </Sidebar>
    </>
  );
};

export default SideBar;
